export const RANGE_TYPE_WEEK = "weekrange";
export const RANGE_TYPE_MONTH = "monthrange";
export const RANGE_TYPE_QUARTER = "quarterrange";
export const RANGE_TYPE_HALF_YEAR = "halfyearrange";
export const RANGE_TYPE_YEAR = "yearrange";

export const TYPE_MONTH = "month";
export const TYPE_YEAR = "year";
export const TYPE_WEEK = "week";
export const TYPE_QUARTER = "quarter";

